// Ez a komponens a navigációs menü működéséért felelős

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stack } from '@mui/material';
import Logo from '../assets/icons/dumbbell.png';

const Navbar: React.FC = () => {
  const location = useLocation(); // Lekérdezzük az aktuális útvonalat, hogy tudjuk, melyik link van éppen aktív állapotban

  return (
    /* A navigációs menü, amely tartalmazza a főoldal, az edzések, a keresés és a naplózott edzések linkeit */
    <Stack
      /* sorban egymás mellé tesszük a menüpontokat */
      direction="row"
      justifyContent="left"
      alignItems="flex-end"
      sx={{
        fontSize: '20px',
        gap: { sm: '32px', xs: '20px' }, // Elemek közötti távolság beállítása, különböző képernyőméretekhez
        mt: { sm: '32px', xs: '20px' }, // Margin top beállítása, különböző képernyőméretekhez
        justifyContent: 'left',
      }}
      px="20px"
    >
      {/* A főoldalra mutató link, iconnal */}
      <Link to="/">
        <img
          src={Logo}
          alt="logo"
          style={{
            width: '50px',
            height: '50px',
            margin: '0 20px',
          }}
        />
      </Link>
      {/* A menüpontok, amelyek a különböző oldalakra navigálnak */}

      {/* Home */}
        <Link
          to="/"
          style={{
            textDecoration: 'none',
            color: 'Black',
            borderBottom: location.pathname === '/' ? '3px solid Black' : 'none',
          }}
        >
          Home
        </Link>
        {/* Exercises */}
        <Link
          to="/exercises"
          style={{
            textDecoration: 'none',
            color: 'Black',
            borderBottom: location.pathname === '/exercises' ? '3px solid Black' : 'none',
          }}
        >
          Exercises
        </Link>
        {/* Search and Log */}
        <Link
          to="/workouts"
          style={{
            textDecoration: 'none',
            color: 'Black',
            borderBottom: location.pathname === '/workouts' ? '3px solid Black' : 'none',
          }}
        >
          Search and Log
        </Link>
        {/* Logged Exercises */}
        <Link
          to="/logged-exercises" // Updated route for Logged Exercises
          style={{
            textDecoration: 'none',
            color: 'Black',
            borderBottom: location.pathname === '/logged-exercises' ? '3px solid Black' : 'none', // Highlight active link
          }}
        >
          Logged Exercises
        </Link>
      </Stack>
  );
};

export default Navbar;
